import React, { useState } from 'react';
import { inject, observer } from "mobx-react";
import Input from '../../../ui/input';
import { logForEnteredPassword } from "../../../../logger/loggerRegForm";

const PasswordInput = inject('appStore', 'kafkaStore')(observer((props) => {
  const { onInput,
    value,
    errorMessage,
    label,
    kafkaStore: {
      imprintHash
    },
  } = props;

  const [iconName, setIconName] = useState(['fa', 'eye']);
  const [inputType, setInputType] = useState('password');
  const [toggleIcon, setToggleIcon] = useState(false);

  const onClick = () => {
    if (toggleIcon) {
      setIconName(['fa', 'eye']);
      setInputType('password');
    } else {
      setIconName(['fa', 'eye-slash']);
      setInputType('text');
    }
    setToggleIcon(!toggleIcon);
  };

  const logBlurPassword = (imprint ) => {
    logForEnteredPassword( imprint)
  }

  const onBlurPassword = () => {
    logBlurPassword(imprintHash);
  }

  return (
    <Input
      onBlur={onBlurPassword}
       className='Password'
       label={label}
       type={inputType}
       value={value}
       onChange={onInput}
       withIcon={iconName}
       iconSize='xs'
       onIconClick={onClick}
       error={errorMessage}
    />
  );
}));

export default PasswordInput;
